<div class="modal-container">
  <div class="modal wider-plus">
    <div class="modal-header">
      <div class="modal-title">Welcome, {{agencyManager.name}}!</div>
      <div class="modal-subtitle">Select your user profile below to continue.</div>
    </div>
    <div class="modal-body">
      <div class="loading-profiles" *ngIf="loading; else profilesTemplate">
        <app-centrui-spinner [sizeInRem]="5"></app-centrui-spinner>
      </div>
      <ng-template #profilesTemplate>
        <div class="profiles-container">
          <div
            class="profile-item animate__animated animate__fadeIn"
            *ngFor="let profile of agencyProfiles"
            [class.selected]="selectedUser?.id === profile.id"
            (click)="selectUser(profile)"
          >
            <div class="profile-avatar">
              <app-centrui-avatar [avatarType]="'profile'" [src]="profile.file"></app-centrui-avatar>
            </div>
            <div class="profile-name">{{profile.name}}</div>
            <div class="profile-email">{{profile.email}}</div>
          </div>
        </div>
      </ng-template>
      <div class="form-elements" [class.single-action]="!canManageProfiles">
        <app-centrui-button *ngIf="canManageProfiles" (click)="launchManageAgencyProfilesModal()" [type]="'button'" [size]="'medium'" [style]="'secondary'" [text]="'Manage Profiles'"></app-centrui-button>
        <app-centrui-button (click)="cancel()" [type]="'button'" [size]="'medium'" [style]="'danger light'" [text]="'Cancel & Logout'"></app-centrui-button>
      </div>
    </div>
  </div>
</div>
